import { render, staticRenderFns } from "./vertical_2.vue?vue&type=template&id=6ff29ed7&scoped=true&"
import script from "./vertical_2.vue?vue&type=script&lang=js&"
export * from "./vertical_2.vue?vue&type=script&lang=js&"
import style0 from "./vertical_2.vue?vue&type=style&index=0&id=6ff29ed7&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ff29ed7",
  null
  
)

export default component.exports